/* LUXBMX workshop calculators: spoke lengths, gearing and chain length.
   Loaded by sections/lux-calculators.liquid. Settings reach the scripts as data
   attributes on the section markup. Add the section once per page: the panels
   use fixed ids. Re-initialises when the theme editor reloads the section. */
/* Stamp refresh 25 Sept 2026: the CDN must fetch this file a minute or more after it is written. */
(function () {
'use strict';

function initTabs(section) {
var root=section.querySelector('#lux-calcs');
if(!root||root.dataset.lcReady)return;
root.dataset.lcReady='1';
var STORAGE='luxCalcsTab';
var KEYS=Array.prototype.map.call(root.querySelectorAll('[data-lc-panel]'),function(p){return p.getAttribute('data-lc-panel')});
if(!KEYS.length)return;
var DEFAULT=root.getAttribute('data-default-tab');
if(KEYS.indexOf(DEFAULT)===-1)DEFAULT=KEYS[0];
var tabsEl=root.querySelector('.lc-tabs');
var tabs={},panels={};
KEYS.forEach(function(k){
tabs[k]=root.querySelector('[data-lc-tab="'+k+'"]');
panels[k]=root.querySelector('[data-lc-panel="'+k+'"]');
});
root.classList.add('is-tabbed');
function show(k,opts){
if(KEYS.indexOf(k)===-1)return;
opts=opts||{};
KEYS.forEach(function(n){
var on=n===k;
if(tabs[n]){
tabs[n].classList.toggle('on',on);
tabs[n].setAttribute('aria-selected',on?'true':'false');
tabs[n].tabIndex=on?0:-1;
}
panels[n].classList.toggle('on',on);
});
try{localStorage.setItem(STORAGE,k)}catch(e){}
if(opts.focus&&tabs[k])tabs[k].focus();
if(opts.hash&&history.replaceState)history.replaceState(null,'','#'+k);
}
KEYS.forEach(function(k){
if(tabs[k])tabs[k].addEventListener('click',function(){show(k,{hash:true})});
});
if(tabsEl)tabsEl.addEventListener('keydown',function(e){
var i=KEYS.indexOf(document.activeElement.getAttribute('data-lc-tab'));
if(i===-1)return;
var n=null;
if(e.key==='ArrowRight')n=(i+1)%KEYS.length;
else if(e.key==='ArrowLeft')n=(i-1+KEYS.length)%KEYS.length;
else if(e.key==='Home')n=0;
else if(e.key==='End')n=KEYS.length-1;
if(n===null)return;
e.preventDefault();
show(KEYS[n],{focus:true,hash:true});
});
function fromHash(){return (location.hash||'').replace('#','').toLowerCase()}
window.addEventListener('hashchange',function(){
var h=fromHash();
if(KEYS.indexOf(h)!==-1){show(h);jump();}
});
var start=fromHash();
if(KEYS.indexOf(start)===-1){
try{start=localStorage.getItem(STORAGE)||DEFAULT}catch(e){start=DEFAULT}
}
if(KEYS.indexOf(start)===-1)start=DEFAULT;
function navType(){try{var e=performance.getEntriesByType('navigation')[0];return e?e.type:''}catch(err){return ''}}
function jump(){
var h=parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'))||70;
var y=(tabsEl||root).getBoundingClientRect().top+window.pageYOffset-h-8;
window.scrollTo(0,Math.max(0,y));
}
show(start);
var designMode=!!(window.Shopify&&window.Shopify.designMode);
if(!designMode&&KEYS.indexOf(fromHash())!==-1&&navType()!=='reload'&&navType()!=='back_forward'){setTimeout(jump,60);}
}

function initSpoke(section) {
var root = section.querySelector('#lux-spoke-calc');
if (!root || root.dataset.ready) return;
root.dataset.ready = '1';
var form = root.querySelector('[data-spoke-form]');
var fields = ['erd', 'spacing', 'pcd_d', 'pcd_nd', 'f2l_d', 'f2l_nd', 'ctf_d', 'ctf_nd',
'spokes', 'cross_d', 'cross_nd', 'hole', 'offset', 'offset_dir', 'symmetric', 'method'];
var el = {};
fields.forEach(function (n) { el[n] = form.elements[n]; });
var results = { d: root.querySelector('[data-result="d"]'), nd: root.querySelector('[data-result="nd"]') };
var statusEl = root.querySelector('[data-status]');
var adviceEl = root.querySelector('[data-advice]');
var warnEl = root.querySelector('[data-warnings]');
var derivedEl = root.querySelector('[data-derived]');
var moreEl = root.querySelector('[data-more]');
var sideLabels = root.querySelectorAll('[data-side-label]');
var STEP = Number(root.dataset.step) || 1;
var HOLE_DEFAULT = Number(root.dataset.holeDefault) || 2.5;
var SHOP_URL = root.dataset.shopUrl || '/collections/bmx-spokes';
var HELP_EMAIL = root.dataset.helpEmail || 'help@luxbmx.com';
var TOL = Number(root.dataset.tolerance) || 1;
var CUT_MIN = 80, CUT_MAX = 220;
// Lengths the spokes collection carries, rendered by Liquid as "|184mm|186mm|" lists.
var stock = { sizes: [], avail: {}, cut: [] };
(function () {
function list(s) { return String(s || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean); }
var availSet = {};
list(root.dataset.stockAvail).forEach(function (v) { availSet[v.toLowerCase()] = true; });
list(root.dataset.stockSizes).forEach(function (v) {
var m = /^(\d+(?:\.\d+)?)\s*mm$/i.exec(v);
if (!m) return;
var n = Number(m[1]);
if (!(n > 0)) return;
if (stock.sizes.indexOf(n) === -1) stock.sizes.push(n);
if (availSet[v.toLowerCase()]) stock.avail[n] = true;
else if (stock.avail[n] !== true) stock.avail[n] = false;
});
stock.sizes.sort(function (a, c) { return a - c; });
stock.cut = list(root.dataset.cutValues);
})();
var touched = {};
var restoredFlag = false;
function warn(tag, err) { if (window.console && console.warn) console.warn('LUX calculator, ' + tag + ': ' + (err && err.message ? err.message : err)); }
var progressEl = root.querySelector('[data-progress]');
var restoredEl = root.querySelector('[data-restored]');
var stripShopEl = root.querySelector('[data-strip-shop]');
var detailEl = root.querySelector('[data-detail]');
var buyEl = root.querySelector('[data-buy-links]');
var combos = {};
var STORAGE = 'lux-spoke-calc-v5';
var MEASURED = ['erd', 'spacing', 'pcd_d', 'pcd_nd', 'f2l_d', 'f2l_nd', 'ctf_d', 'ctf_nd'];
var NAMES = {
erd: 'the ERD', spacing: 'the hub spacing',
pcd_d: 'the drive side flange diameter', pcd_nd: 'the non-drive side flange diameter',
f2l_d: 'drive side flange to locknut', f2l_nd: 'non-drive side flange to locknut',
ctf_d: 'centre to drive side flange', ctf_nd: 'centre to non-drive side flange'
};
function num(name) {
var v = String(el[name].value).trim().replace(',', '.');
if (v === '') return NaN;
var n = Number(v);
return isFinite(n) ? n : NaN;
}
function fmt(n, dp) { return Number(n).toFixed(dp); }
function spokeLength(erd, pcd, d, spokes, crosses, hole) {
var R = erd / 2;
var r = pcd / 2;
var a = (2 * Math.PI * crosses) / (spokes / 2);
var sq = R * R + r * r + d * d - 2 * R * r * Math.cos(a);
if (sq < 0) return NaN;
return Math.sqrt(sq) - hole / 2;
}
function stocked(len, step) {
var lower = Math.floor(len / step + 1e-9) * step;
var upper = lower + step;
var frac = (len - lower) / step;
return { pick: frac >= 0.5 ? upper : lower, lower: lower, upper: upper, borderline: Math.abs(frac - 0.5) < 0.15 };
}
function snap(len) {
var sizes = stock.sizes;
if (!sizes.length) {
var st = stocked(len, STEP);
return { state: 'buy', pick: st.pick, alt: st.borderline ? (st.pick === st.lower ? st.upper : st.lower) : null, exact: len, lo: st.lower, hi: st.upper };
}
var lo = null, hi = null, i;
for (i = 0; i < sizes.length; i++) {
if (sizes[i] <= len) lo = sizes[i];
if (sizes[i] >= len) { hi = sizes[i]; break; }
}
var cands = [];
if (lo !== null && len - lo <= TOL + 1e-9) cands.push(lo);
if (hi !== null && hi !== lo && hi - len <= TOL + 1e-9) cands.push(hi);
if (!cands.length) return { state: 'gap', pick: null, alt: null, exact: len, lo: lo, hi: hi };
cands.sort(function (a, c) {
var aa = stock.avail[a] === true ? 0 : 1, ca = stock.avail[c] === true ? 0 : 1;
if (aa !== ca) return aa - ca;
var da = Math.abs(a - len), dc = Math.abs(c - len);
if (Math.abs(da - dc) > 1e-9) return da - dc;
return a - c;
});
return { state: 'buy', pick: cands[0], alt: cands.length > 1 ? cands[1] : null, exact: len, lo: lo, hi: hi };
}
function lengthParam(n) { return 'filter.v.option.length=' + encodeURIComponent(n + 'mm'); }
function shopUrl() {
var parts = [], seen = {};
Array.prototype.forEach.call(arguments, function (n) {
if (n === null || n === undefined || isNaN(n) || seen[n]) return;
seen[n] = true; parts.push(lengthParam(n));
});
return SHOP_URL + (parts.length ? '?' + parts.join('&') : '');
}
function cutUrl() {
if (!stock.cut.length) return SHOP_URL;
return SHOP_URL + '?' + stock.cut.map(function (v) { return 'filter.v.option.length=' + encodeURIComponent(v); }).join('&');
}
function stockWord(n) {
var a = stock.avail[n];
return a === true ? ', in stock' : (a === false ? ', out of stock at the moment' : '');
}
function sideLine(label, count, s, exactText) {
var html = '<div class="lux-spoke__buy-side"><strong>' + label + '</strong> ' + exactText + ' ';
if (s.state === 'buy') {
html += 'Buy <strong>' + count + ' × ' + s.pick + ' mm</strong>' + stockWord(s.pick) + '.';
if (s.alt !== null) html += ' <a href="' + shopUrl(s.alt) + '">' + s.alt + ' mm</a> also fits' + stockWord(s.alt) + '.';
html += '<br><a class="lux-spoke__buy-btn" href="' + shopUrl(s.pick) + '">Shop ' + s.pick + ' mm spokes</a>';
} else {
var near = [];
if (s.lo !== null) near.push(s.lo + ' mm');
if (s.hi !== null) near.push(s.hi + ' mm');
html += 'We don’t carry that length off the shelf' + (near.length ? '. Nearest we do are ' + near.join(' and ') : '') + '.';
if (stock.cut.length && s.exact >= CUT_MIN && s.exact <= CUT_MAX) {
html += ' A cut-to-size spoke covers it.<br><a class="lux-spoke__buy-btn" href="' + cutUrl() + '">Shop cut-to-size spokes</a>';
} else {
html += ' Email <a href="mailto:' + esc(HELP_EMAIL) + '">' + esc(HELP_EMAIL) + '</a> and we’ll sort it.';
}
}
return html + '</div>';
}
function buyHtml(sD, sN, v) {
var half = v.spokes / 2;
if (sD.state === 'buy' && sN.state === 'buy' && sD.pick === sN.pick) {
var merged = { state: 'buy', pick: sD.pick, alt: sD.alt !== null ? sD.alt : sN.alt, exact: sD.exact, lo: sD.lo, hi: sD.hi };
var ex = Math.abs(sD.exact - sN.exact) < 0.05
? fmt(sD.exact, 1) + ' mm calculated.'
: 'Drive side ' + fmt(sD.exact, 1) + ' mm, non-drive side ' + fmt(sN.exact, 1) + ' mm calculated.';
return sideLine('Both sides:', v.spokes, merged, ex);
}
return sideLine('Drive side:', half, sD, fmt(sD.exact, 1) + ' mm calculated.') +
sideLine('Non-drive side:', half, sN, fmt(sN.exact, 1) + ' mm calculated.');
}
function maxSensibleCross(spokes) { return Math.floor(spokes / 8); }
function bearsOnFlange(erd, pcd, spokes, crosses) {
if (!crosses || !(erd > 0) || !(pcd > 0)) return false;
var a = (2 * Math.PI * crosses) / (spokes / 2);
return Math.cos(a) < pcd / erd;
}
var LIMITS = {
erd:     { min: 150, max: 700, name: 'ERD', note: 'a bicycle rim ERD is between about 150 and 700 mm' },
spacing: { min: 70,  max: 200, name: 'Hub spacing', note: 'hub spacing is between about 70 and 200 mm, 100 mm front and 110 mm rear on most BMX' },
pcd_d:   { min: 20,  max: 120, name: 'Flange diameter', note: 'a hub flange spoke circle is between about 20 and 120 mm' },
pcd_nd:   { min: 20,  max: 120, name: 'Flange diameter', note: 'a hub flange spoke circle is between about 20 and 120 mm' },
hole:    { min: 1.5, max: 4,   name: 'Spoke hole diameter', note: 'a spoke hole is between about 1.5 and 4 mm, usually 2.4 to 2.6 mm on BMX' }
};
function readInputs() {
var symmetric = el.symmetric.checked;
var useCtf = el.method.value === 'ctf';
var v = {
erd: num('erd'), spacing: num('spacing'),
pcdD: num('pcd_d'), pcdN: symmetric ? num('pcd_d') : num('pcd_nd'),
spokes: Number(el.spokes.value),
crossD: Number(el.cross_d.value),
hole: num('hole'), offset: num('offset'), offsetDir: el.offset_dir.value,
symmetric: symmetric, useCtf: useCtf
};
v.crossN = el.cross_nd.value === 'same' ? v.crossD : Number(el.cross_nd.value);
if (isNaN(v.hole) || v.hole <= 0) v.hole = HOLE_DEFAULT;
v.offset = isNaN(v.offset) ? 0 : Math.abs(v.offset);
if (useCtf) {
v.ctfD = num('ctf_d');
v.ctfN = symmetric ? num('ctf_d') : num('ctf_nd');
} else {
var f2lD = num('f2l_d');
var f2lN = symmetric ? num('f2l_d') : num('f2l_nd');
v.f2lD = f2lD; v.f2lN = f2lN;
v.ctfD = v.spacing / 2 - f2lD;
v.ctfN = v.spacing / 2 - f2lN;
}
var o = v.offsetDir === 'none' ? 0 : v.offset;
v.dD = v.ctfD - (v.offsetDir === 'd' ? o : 0) + (v.offsetDir === 'nd' ? o : 0);
v.dN = v.ctfN - (v.offsetDir === 'nd' ? o : 0) + (v.offsetDir === 'd' ? o : 0);
return v;
}
function requiredFor(v) {
var need = ['erd', 'spacing', 'pcd_d'];
if (!v.symmetric) need.push('pcd_nd');
if (v.useCtf) {
need.push('ctf_d');
if (!v.symmetric) need.push('ctf_nd');
} else {
need.push('f2l_d');
if (!v.symmetric) need.push('f2l_nd');
}
return need;
}
function renderSide(side, len) {
var box = results[side];
var buy = box.querySelector('[data-buy]');
var exact = box.querySelector('[data-exact]');
if (isNaN(len)) {
box.classList.add('is-empty'); box.classList.remove('is-ready'); box.classList.remove('is-gap');
buy.textContent = '—'; exact.textContent = '';
return null;
}
var s = snap(len);
box.classList.remove('is-empty');
box.classList.toggle('is-ready', s.state === 'buy');
box.classList.toggle('is-gap', s.state !== 'buy');
if (s.state === 'buy') {
buy.textContent = s.pick;
exact.textContent = fmt(len, 1) + ' mm calculated' + (s.alt !== null ? ' · ' + s.alt + ' also fits' : '');
} else {
buy.textContent = Math.round(len);
exact.textContent = fmt(len, 1) + ' mm calculated · not a size we carry';
}
return s;
}
function renderDerived(v) {
var usable = !isNaN(v.spacing) && v.spacing > 0 && !isNaN(v.ctfD) && !isNaN(v.ctfN) && v.ctfD > 0 && v.ctfN > 0;
if (!usable) { derivedEl.hidden = true; return; }
if (v.useCtf) {
var fromD = v.spacing / 2 - v.ctfD;
var fromN = v.spacing / 2 - v.ctfN;
if (fromD <= 0 || fromN <= 0) { derivedEl.hidden = true; return; }
derivedEl.hidden = false;
derivedEl.innerHTML = v.symmetric
? 'Same as <strong>' + fmt(fromD, 1) + ' mm</strong> in from each locknut.'
: 'Same as <strong>' + fmt(fromD, 1) + ' mm</strong> (drive side) and <strong>' + fmt(fromN, 1) + ' mm</strong> (non-drive side) in from the locknuts.';
} else {
derivedEl.hidden = false;
derivedEl.innerHTML = v.symmetric
? 'That puts each flange <strong>' + fmt(v.ctfD, 1) + ' mm</strong> from the centre of the wheel.'
: 'That puts the flanges <strong>' + fmt(v.ctfD, 1) + ' mm</strong> (drive side) and <strong>' + fmt(v.ctfN, 1) + ' mm</strong> (non-drive side) from the centre of the wheel.';
}
}
function update() {
var v = readInputs();
root.classList.toggle('is-symmetric', v.symmetric);
root.classList.toggle('is-mode-ctf', v.useCtf);
Array.prototype.forEach.call(sideLabels, function (n) { n.textContent = v.symmetric ? 'Both sides' : 'Drive side'; });
Array.prototype.forEach.call(root.querySelectorAll('[data-aria]'), function (i) {
i.setAttribute('aria-label', i.dataset.aria + ', ' + (i.dataset.side === 'nd' ? 'non-drive side' : (v.symmetric ? 'both sides' : 'drive side')));
});
root.classList.toggle('is-mode-locknut', !v.useCtf);
var required = requiredFor(v);
var missing = [];
MEASURED.forEach(function (k) {
var input = el[k];
var raw = input.value !== '';
var n = num(k);
var bad = isNaN(n) || n <= 0;
input.classList.toggle('is-filled', raw && !bad);
input.classList.toggle('is-invalid', raw && bad);
if (required.indexOf(k) !== -1 && bad) missing.push(k);
});
el.hole.classList.toggle('is-invalid', el.hole.value !== '' && (isNaN(num('hole')) || num('hole') <= 0));
el.offset.classList.remove('is-invalid');
var warnings = [];
var fatal = [];
var lenD = NaN, lenN = NaN;
var ready = missing.length === 0;
Object.keys(LIMITS).forEach(function (k) {
var input = el[k];
if (!input || input.value === '') return;
if (k === 'pcd_nd' && v.symmetric) return;
if (!ready && !touched[k]) return;
var n = num(k), lim = LIMITS[k];
if (isNaN(n) || n < lim.min || n > lim.max) {
input.classList.add('is-invalid');
fatal.push(lim.name + ' of ' + (isNaN(n) ? input.value : fmt(n, 1)) + ' mm cannot be right: ' + lim.note + '. Check the figure and the units.');
ready = false;
}
});
if (ready) {
if (v.pcdD >= v.erd || v.pcdN >= v.erd) {
fatal.push('The flange diameter is bigger than the ERD. Check the rim and hub numbers are not swapped.');
if (v.pcdD >= v.erd) el.pcd_d.classList.add('is-invalid');
if (v.pcdN >= v.erd && !v.symmetric) el.pcd_nd.classList.add('is-invalid');
el.erd.classList.add('is-invalid');
ready = false;
} else if (v.useCtf && (v.ctfD >= v.spacing / 2 || v.ctfN >= v.spacing / 2)) {
fatal.push('A flange cannot sit further from the centre than half the hub width (' + fmt(v.spacing / 2, 1) + ' mm). Check the centre-to-flange figures against the hub spacing.');
el.spacing.classList.add('is-invalid');
if (v.ctfD >= v.spacing / 2) el.ctf_d.classList.add('is-invalid');
if (v.ctfN >= v.spacing / 2 && !v.symmetric) el.ctf_nd.classList.add('is-invalid');
ready = false;
} else if (!v.useCtf && (v.ctfD <= 0 || v.ctfN <= 0)) {
fatal.push('Flange to locknut is more than half the hub spacing, which cannot be right. Re-check those two measurements.');
el.spacing.classList.add('is-invalid');
if (v.ctfD <= 0) el.f2l_d.classList.add('is-invalid');
if (v.ctfN <= 0 && !v.symmetric) el.f2l_nd.classList.add('is-invalid');
ready = false;
} else if (v.dD <= 0 || v.dN <= 0) {
fatal.push('The rim offset is bigger than the centre‑to‑flange distance, which is not possible. Check the offset under More options.');
el.offset.classList.add('is-invalid');
ready = false;
} else {
lenD = spokeLength(v.erd, v.pcdD, v.dD, v.spokes, v.crossD, v.hole);
lenN = spokeLength(v.erd, v.pcdN, v.dN, v.spokes, v.crossN, v.hole);
var mx = maxSensibleCross(v.spokes);
var worst = Math.max(v.crossD, v.crossN);
if (worst > mx) {
warnings.push(worst + ' cross on a ' + v.spokes + '-hole wheel is an unusual build. ' + mx + ' cross is normally the most you would lace at that spoke count, and is the safe choice. The length above is still correct for ' + worst + ' cross if that is really what you are lacing.');
}
var bindD = bearsOnFlange(v.erd, v.pcdD, v.spokes, v.crossD);
var bindN = bearsOnFlange(v.erd, v.pcdN, v.spokes, v.crossN);
if (bindD || bindN) {
warnings.push('At ' + worst + ' cross on a ' + v.spokes + '-hole wheel the spokes leave the flange ' +
(bindD && bindN ? '' : (bindD ? 'on the drive side ' : 'on the non-drive side ')) +
'pointing back towards the axle, so they will bear hard against the edge of the flange. That is the geometric limit for this hub and rim. The wheel can be built, but expect the spokes to touch where they cross the flange.');
}
if (v.hole > 3.2) warnings.push('Spoke hole diameter is usually 2.4 to 2.6 mm on BMX hubs. A bigger value shortens the result.');
if (!v.symmetric && v.pcdN > v.pcdD) {
warnings.push('The non-drive side flange is bigger than the drive side one. On nearly every hub the drive side flange is the bigger of the two, so check the sides are not swapped. Left or right hand drive makes no difference here: the drive side is whichever side the driver is on.');
}
}
}
renderDerived(v);
var sD = renderSide('d', lenD);
var sN = renderSide('nd', lenN);
var done = required.length - missing.length;
if (progressEl) {
progressEl.textContent = done + ' of ' + required.length;
progressEl.hidden = !!(sD && sN);
}
if (restoredEl) restoredEl.hidden = !restoredFlag;
var half = v.spokes / 2;
var shopBoth = '';
if (sD && sN) {
if (sD.state === 'buy' && sN.state === 'buy') {
if (sD.pick === sN.pick) {
statusEl.textContent = 'Both sides take the same spoke: ' + v.spokes + ' × ' + sD.pick + ' mm.';
} else {
statusEl.textContent = half + ' × ' + sD.pick + ' mm for the drive side and ' + half + ' × ' + sN.pick + ' mm for the non-drive side.';
}
shopBoth = shopUrl(sD.pick, sN.pick);
} else if (sD.state === 'buy' || sN.state === 'buy') {
var okS = sD.state === 'buy' ? sD : sN, gapS = sD.state === 'buy' ? sN : sD;
var okSide = sD.state === 'buy' ? 'drive side' : 'non-drive side', gapSide = sD.state === 'buy' ? 'non-drive side' : 'drive side';
statusEl.textContent = half + ' × ' + okS.pick + ' mm for the ' + okSide + '. The ' + gapSide + ' works out at ' + fmt(gapS.exact, 1) + ' mm, which we don’t carry off the shelf. See below.';
shopBoth = shopUrl(okS.pick);
} else {
statusEl.textContent = 'Neither length is a size we carry off the shelf. See below for your options.';
}
statusEl.classList.add('is-ready');
} else if (missing.length) {
statusEl.textContent = 'Next: ' + NAMES[missing[0]] + '.';
statusEl.classList.remove('is-ready');
} else if (fatal.length) {
statusEl.textContent = 'No length given: one of the measurements can’t be right.';
statusEl.classList.remove('is-ready');
} else {
statusEl.textContent = 'Those numbers don’t add up. See the note below.';
statusEl.classList.remove('is-ready');
}
if (stripShopEl) {
var stripLink = stripShopEl.querySelector('a');
if (shopBoth && stripLink) { stripLink.href = shopBoth; stripShopEl.hidden = false; } else { stripShopEl.hidden = true; }
}
if (buyEl) {
buyEl.innerHTML = (sD && sN) ? buyHtml(sD, sN, v) : '';
buyEl.hidden = !(sD && sN);
}
if (adviceEl) {
if (sD && sN) {
adviceEl.innerHTML = 'Anything within about <strong>&plusmn;1 mm</strong> of the calculated figure builds fine. Which way to lean depends on your rim, your nipples and how much thread engagement you want: go a touch short if the nipples are shallow and a touch long if you want more thread in them.';
adviceEl.hidden = false;
} else {
adviceEl.hidden = true;
}
}
warnEl.innerHTML = fatal.map(function (w) { return '<li class="is-fatal">' + w + '</li>'; })
.concat(warnings.map(function (w) { return '<li>' + w + '</li>'; })).join('');
warnEl.hidden = fatal.length + warnings.length === 0;
if (detailEl) detailEl.hidden = !(sD && sN) && warnEl.hidden;
if (moreEl && !moreEl.open && (el.cross_nd.value !== 'same' || (el.offset.value !== '' && Number(el.offset.value) !== 0 && el.offset_dir.value !== 'none'))) moreEl.open = true;
persist();
}
function persist() {
try {
var data = {};
fields.forEach(function (n) { data[n] = el[n].type === 'checkbox' ? el[n].checked : el[n].value; });
localStorage.setItem(STORAGE, JSON.stringify(data));
} catch (e) {}
}
function restore() {
try {
var data = JSON.parse(localStorage.getItem(STORAGE) || 'null');
if (!data) return;
fields.forEach(function (n) {
if (!(n in data)) return;
if (el[n].type === 'checkbox') { el[n].checked = !!data[n]; return; }
if (el[n].tagName === 'SELECT') {
var ok = false;
for (var i = 0; i < el[n].options.length; i++) {
if (el[n].options[i].value === String(data[n])) { ok = true; break; }
}
if (!ok) return;
}
el[n].value = data[n];
});
restoredFlag = MEASURED.some(function (n) { return el[n].value !== ''; });
} catch (e) {}
}
function carryAcross(toMethod) {
var spacing = num('spacing');
if (isNaN(spacing) || spacing <= 0) return;
['d', 'nd'].forEach(function (side) {
var from = toMethod === 'ctf' ? 'f2l_' + side : 'ctf_' + side;
var to = toMethod === 'ctf' ? 'ctf_' + side : 'f2l_' + side;
if (el[to].value !== '') return;
var have = num(from);
if (isNaN(have)) return;
var converted = spacing / 2 - have;
if (converted > 0) el[to].value = String(Math.round(converted * 10) / 10);
});
}
Array.prototype.forEach.call(el.method, function (radio) {
radio.addEventListener('change', function () {
if (radio.checked) carryAcross(radio.value);
});
});
var pops = Array.prototype.slice.call(root.querySelectorAll('[data-pop]'));
function closePops() {
pops.forEach(function (p) {
p.hidden = true;
p.classList.remove('is-above');
p.style.marginTop = '';
var b = p.parentNode.querySelector('[data-pop-btn]');
if (b) b.setAttribute('aria-expanded', 'false');
});
root.classList.remove('has-pop');
}
if (pops.length) {
root.addEventListener('click', function (e) {
var t = e.target;
if (!t || !t.closest) return;
var btn = t.closest('[data-pop-btn]');
if (btn) {
e.preventDefault();
var pop = btn.parentNode.querySelector('[data-pop]');
var opening = pop.hidden;
closePops();
if (opening) {
pop.hidden = false;
btn.setAttribute('aria-expanded', 'true');
root.classList.add('has-pop');
pop.classList.remove('is-above');
pop.style.marginTop = '';
if (window.innerWidth > 640) {
var pr = pop.getBoundingClientRect(), br = btn.getBoundingClientRect(), vh = window.innerHeight;
if (pr.bottom > vh - 8) {
if (br.top - 16 > pr.height) {
pop.classList.add('is-above');
} else {
var hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
var shift = Math.min(pr.bottom - (vh - 8), Math.max(0, pr.top - hh - 8));
if (shift > 0) pop.style.marginTop = (-shift) + 'px';
}
}
}
}
return;
}
if (t.closest('[data-pop-close]')) { e.preventDefault(); closePops(); return; }
if (!t.closest('[data-pop]')) closePops();
});
document.addEventListener('click', function (e) { if (!root.contains(e.target)) closePops(); });
document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.key === 'Esc') closePops(); });
}
form.addEventListener('input', function () { restoredFlag = false; update(); });
form.addEventListener('focusout', function (e) {
var t = e.target;
if (t && t.name && MEASURED.indexOf(t.name) !== -1 && !touched[t.name]) { touched[t.name] = true; update(); }
});
form.addEventListener('change', update);
form.addEventListener('submit', function (e) { e.preventDefault(); update(); });
window.addEventListener('pageshow', update);
Array.prototype.forEach.call(root.querySelectorAll('[data-reset]'), function (btn) {
btn.addEventListener('click', function () {
MEASURED.forEach(function (n) { el[n].value = ''; });
el.spokes.value = '36'; el.cross_d.value = '3'; el.cross_nd.value = 'same';
el.hole.value = String(HOLE_DEFAULT); el.offset.value = '0'; el.offset_dir.value = 'none';
el.symmetric.checked = false; el.method.value = 'locknut';
if (moreEl) moreEl.open = false;
try { localStorage.removeItem(STORAGE); } catch (e) {}
restoredFlag = false; touched = {};
clearPick('rim'); clearPick('hub');
update();
el.erd.focus();
});
});
var PICK_URL = root.dataset.pickUrl || '', PICK_CACHE = 'luxWheelData_v1';
var filling = false;
function slugOf(t) {
return String(t).toLowerCase().replace(/&/g, '-').replace(/\//g, '-')
.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
}
function esc(s) {
return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function setSpokes(n) {
var opts = el.spokes.options;
for (var i = 0; i < opts.length; i++) if (Number(opts[i].value) === Number(n)) { el.spokes.value = opts[i].value; return; }
}
function pickNote(kind, title, handle) {
var box = root.querySelector('[data-picked="' + kind + '"]');
if (!box) return;
box.innerHTML = 'Filled in from <a href="/products/' + esc(handle) + '">' + esc(title) + '</a>.';
box.hidden = false;
}
function setSpacingNote(text) {
var n = root.querySelector('[data-spacing-note]');
if (!n) return;
n.textContent = text || '';
n.hidden = !text;
}
function clearPickNote(kind) {
var box = root.querySelector('[data-picked="' + kind + '"]');
if (box) { box.hidden = true; box.innerHTML = ''; }
if (kind === 'hub') setSpacingNote('');
}
function clearPick(kind) {
if (combos[kind]) combos[kind].reset();
clearPickNote(kind);
}
function applyRim(r) {
filling = true;
el.erd.value = r[2];
if (r[3] && r[3].length === 1) setSpokes(r[3][0]);
filling = false;
pickNote('rim', r[0], r[1] || slugOf(r[0]));
update();
}
function applyHub(h) {
var front = h[2], pl = h[3], pr = h[4], sp = h[5], aL = h[6], aR = h[7], isF2L = h[8], holes = h[9],
spGuessed = h[10];
// Which column is the drive side? Rows with a 12th value of 1 say so: the right
// column is the drive side. Older rows are guessed: hubs come left or right hand
// drive, and the bigger flange is almost always the drive side. With matching
// flanges the drive side is the one the driver pushes closer to the centre, except
// on a disc hub, where the rotor pushes the non-drive flange in instead. If both
// match it makes no difference.
var driveRight = true;
if (h[11] === 1) {
driveRight = true;
} else if (pl !== pr) {
driveRight = pr > pl;
} else if (aL !== aR) {
var rightCloser = isF2L ? aR > aL : aR < aL;
var disc = /\bdisc\b/i.test(String(h[0]));
driveRight = disc ? !rightCloser : rightCloser;
}
var pD = driveRight ? pr : pl, pN = driveRight ? pl : pr, aD = driveRight ? aR : aL, aN = driveRight ? aL : aR;
filling = true;
el.symmetric.checked = (pl === pr && aL === aR);
el.pcd_d.value = pD; el.pcd_nd.value = pN;
el.method.value = isF2L ? 'locknut' : 'ctf';
if (isF2L) { el.f2l_d.value = aD; el.f2l_nd.value = aN; el.ctf_d.value = ''; el.ctf_nd.value = ''; }
else { el.ctf_d.value = aD; el.ctf_nd.value = aN; el.f2l_d.value = ''; el.f2l_nd.value = ''; }
if (sp) el.spacing.value = sp;
if (holes && holes.length === 1) setSpokes(holes[0]);
filling = false;
pickNote('hub', h[0], h[1] || slugOf(h[0]));
setSpacingNote(spGuessed ? 'Assumed. This hub’s spacing isn’t published, so we’ve used the usual ' + sp + ' mm. Check yours and change it if it differs.' : '');
update();
}
function initCombo(kind, rows, tagOf, onPick) {
var box = root.querySelector('[data-combo="' + kind + '"]');
if (!box) return null;
var input = box.querySelector('input');
var list = box.querySelector('ul');
var clearBtn = box.querySelector('[data-combo-clear]');
var idBase = 'lux-pick-' + kind + '-';
var items = rows.map(function (row, i) {
return { i: i, row: row, name: String(row[0]), key: String(row[0]).toLowerCase(), tag: tagOf(row) };
}).sort(function (a, c) { return a.key < c.key ? -1 : (a.key > c.key ? 1 : 0); });
var shown = [], active = -1, selected = null;
function filter(q) {
var t = q.toLowerCase().split(/\s+/).filter(Boolean);
return items.filter(function (it) {
for (var k = 0; k < t.length; k++) { if (it.key.indexOf(t[k]) === -1) return false; }
return true;
});
}
function render(q) {
shown = filter(q);
active = -1;
var html = '';
if (!shown.length) {
html = '<li class="lux-spoke__opt-empty" role="presentation">Nothing matching \u201c' + esc(q) + '\u201d. Type your own numbers below.</li>';
} else {
shown.forEach(function (it, n) {
html += '<li role="option" id="' + idBase + it.i + '" data-n="' + n + '" aria-selected="' + (selected === it ? 'true' : 'false') + '"><span class="lux-spoke__opt-name">' + esc(it.name) + '</span>' + (it.tag ? '<span class="lux-spoke__opt-tag">' + esc(it.tag) + '</span>' : '') + '</li>';
});
}
list.innerHTML = html;
}
function open() { render(input.value); list.hidden = false; input.setAttribute('aria-expanded', 'true'); }
function close() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; }
function setActive(n) {
var lis = list.querySelectorAll('li[role="option"]');
if (!lis.length) return;
if (n < 0) n = lis.length - 1;
if (n >= lis.length) n = 0;
Array.prototype.forEach.call(lis, function (li) { li.classList.remove('is-active'); });
active = n;
lis[n].classList.add('is-active');
input.setAttribute('aria-activedescendant', lis[n].id);
if (lis[n].scrollIntoView) lis[n].scrollIntoView({ block: 'nearest' });
}
function choose(n) {
var it = shown[n];
if (!it) return;
selected = it;
input.value = it.name;
box.classList.add('has-value');
close();
onPick(it.row);
}
function reset() {
selected = null;
input.value = '';
box.classList.remove('has-value');
close();
}
function selectRow(row) {
var it = null;
for (var i = 0; i < items.length; i++) if (items[i].row === row) { it = items[i]; break; }
if (!it) return false;
selected = it;
input.value = it.name;
box.classList.add('has-value');
close();
onPick(it.row);
return true;
}
input.addEventListener('focus', open);
input.addEventListener('click', function () { if (list.hidden) open(); });
input.addEventListener('input', function () {
if (selected && input.value !== selected.name) { selected = null; box.classList.remove('has-value'); clearPickNote(kind); }
open();
});
input.addEventListener('keydown', function (e) {
if (e.key === 'ArrowDown') { if (list.hidden) open(); setActive(active + 1); e.preventDefault(); }
else if (e.key === 'ArrowUp') { if (list.hidden) open(); setActive(active - 1); e.preventDefault(); }
else if (e.key === 'Enter') {
if (!list.hidden && active >= 0) { choose(active); e.preventDefault(); }
else if (!list.hidden && shown.length === 1) { choose(0); e.preventDefault(); }
}
else if (e.key === 'Escape' || e.key === 'Esc') { if (!list.hidden) { close(); e.stopPropagation(); } }
else if (e.key === 'Tab') { close(); }
});
list.addEventListener('mousedown', function (e) { e.preventDefault(); });
list.addEventListener('click', function (e) {
var li = e.target.closest ? e.target.closest('li[role="option"]') : null;
if (li) choose(Number(li.dataset.n));
});
clearBtn.addEventListener('click', function () { reset(); clearPickNote(kind); input.focus(); });
document.addEventListener('click', function (e) { if (!box.contains(e.target)) close(); });
return { reset: reset, select: selectRow };
}
/* ?rim=<handle> or ?hub=<handle> on the page, put there by the light calculators on product pages:
   pick that product as if the customer had chosen it, then drop the parameters so a reload does
   not put it back over whatever they change. */
function applyQuery(data) {
var qs;
try { qs = new URLSearchParams(location.search); } catch (e) { return; }
var touched = false;
['rim', 'hub'].forEach(function (kind) {
var h = qs.get(kind);
if (!h) return;
touched = true;
var rows = kind === 'rim' ? data.r : data.h, hl = String(h).toLowerCase(), row = null;
for (var i = 0; i < rows.length; i++) {
var rr = rows[i];
if ((rr[1] && String(rr[1]).toLowerCase() === hl) || slugOf(rr[0]) === hl) { row = rr; break; }
}
if (row && combos[kind]) combos[kind].select(row);
});
if (!touched) return;
persist();
qs.delete('rim'); qs.delete('hub');
var q = qs.toString();
try { history.replaceState(null, '', location.pathname + (q ? '?' + q : '') + location.hash); } catch (e) {}
}
function buildPickers(data) {
if (!data || !data.r || !data.h) return;
combos.rim = initCombo('rim', data.r, function (r) { return r[2] ? r[2] + ' mm' : ''; }, applyRim);
combos.hub = initCombo('hub', data.h, function (h) { return h[2] ? 'Front' : 'Rear'; }, applyHub);
if (!combos.rim || !combos.hub) return;
root.querySelectorAll('[data-picker]').forEach(function (p) { p.hidden = false; });
var RIMF = ['erd'], HUBF = ['spacing', 'pcd_d', 'pcd_nd', 'f2l_d', 'f2l_nd', 'ctf_d', 'ctf_nd'];
RIMF.concat(HUBF).forEach(function (k) {
if (!el[k]) return;
el[k].addEventListener('input', function () {
if (filling) return;
clearPick(RIMF.indexOf(k) !== -1 ? 'rim' : 'hub');
});
});
applyQuery(data);
}
var wheelRequested = false;
function loadWheelData() {
if (!PICK_URL || wheelRequested) return;
wheelRequested = true;
var cached = null;
try { cached = JSON.parse(sessionStorage.getItem(PICK_CACHE) || 'null'); } catch (e) {}
if (cached) { try { buildPickers(cached); } catch (err) { warn('wheel data', err); } return; }
if (typeof fetch !== 'function') return;
fetch(PICK_URL, { credentials: 'same-origin' })
.then(function (res) { if (!res.ok) throw new Error('http ' + res.status); return res.text(); })
.then(function (html) {
var doc = new DOMParser().parseFromString(html, 'text/html');
var tag = doc.getElementById('lux-wheel-data');
if (!tag) throw new Error('no data block');
var data = JSON.parse(tag.textContent);
try { sessionStorage.setItem(PICK_CACHE, JSON.stringify(data)); } catch (e) {}
buildPickers(data);
})
.catch(function (err) { warn('wheel data', err); });
}
function preloadPops() {
Array.prototype.forEach.call(root.querySelectorAll('[data-pop] img'), function (img) {
img.loading = 'eager';
var i = new Image(); i.src = img.getAttribute('src');
});
}
if (/[?&](rim|hub)=/.test(location.search)) loadWheelData();
if (window.IntersectionObserver) {
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); loadWheelData(); preloadPops(); } });
});
io.observe(form);
} else {
loadWheelData(); preloadPops();
}
restore();
update();
}

function initGear(section) {
var TYRES=[
/* Brand tyres: the outside (inflated) diameter each brand publishes, in mm, converted to inches. Listed first because they beat the generic sizes. */
{g:'Alienation',o:[
['Alienation TCS R1 20 × 1.60 (498 mm)',498/25.4],['Alienation TCS R2 20 × 1.75 (505 mm)',505/25.4],['Alienation Prowler 20 × 2.40 (529 mm)',529/25.4]]},
{g:'Box',o:[
['Box One / Two 20 × 1-1/8 (508 mm)',508/25.4],['Box One / Two 20 × 1-3/8 (523 mm)',523/25.4],['Box One / Two 20 × 1.50 (492 mm)',492/25.4],
['Box One / Two 20 × 1.75 (498 mm)',498/25.4],['Box One / Two 20 × 1.90 (509 mm)',509/25.4],['Box One / Two 24 × 1.75 (598 mm)',598/25.4]]},
{g:'Radio',o:[
['Radio Oxygen 20 × 1.60 (488 mm)',488/25.4],['Radio Oxygen 20 × 1.75 (498 mm)',498/25.4],['Radio Oxygen 20 × 1.95 (508 mm)',508/25.4]]},
{g:'S&M',o:[
['S&M Trackmark 20 × 1.75 (498.5 mm)',498.5/25.4],['S&M Trackmark 20 × 1.95 (508 mm)',508/25.4],['S&M Trackmark 20 × 2.10 (517.5 mm)',517.5/25.4],
['S&M Trackmark 24 × 1.75 (600 mm)',600/25.4],['S&M Trackmark 24 × 2.10 (619 mm)',619/25.4],['S&M Mainline 20 × 2.20 (521 mm)',521/25.4],
['S&M Mainline 20 × 2.40 (532 mm)',532/25.4],['S&M Mainline 22 × 2.20 (568 mm)',568/25.4],['S&M Mainline 22 × 2.40 (576 mm)',576/25.4],
['S&M Speedball 20 × 2.40 (533 mm)',533/25.4],['S&M Speedball 22 × 2.25 (559 mm)',559/25.4],['S&M Speedball 22 × 2.40 (565 mm)',565/25.4],
['S&M Speedball 26 × 2.40 (673 mm)',673/25.4],['S&M Speedball 29 × 2.40 (733 mm)',733/25.4]]},
{g:'Tioga',o:[
['Tioga PowerBlock 20 × 1-1/8 (518 mm)',518/25.4],['Tioga PowerBlock 20 × 1-3/8 (531 mm)',531/25.4],['Tioga PowerBlock 20 × 1.60 (495 mm)',495/25.4],
['Tioga PowerBlock 20 × 1.75 (506 mm)',506/25.4],['Tioga PowerBlock 20 × 1.95 (515 mm)',515/25.4],['Tioga PowerBlock 20 × 2.10 (522 mm)',522/25.4],
['Tioga PowerBlock OS20 × 1.60 (534 mm)',534/25.4],['Tioga PowerBlock OS20 × 1.85 (548 mm)',548/25.4],['Tioga PowerBlock 24 × 1.60 (600 mm)',600/25.4],
['Tioga PowerBlock 24 × 1.75 (610 mm)',610/25.4],['Tioga PowerBlock 24 × 2.10 (624 mm)',624/25.4],['Tioga Fastr-X 20 × 1-1/8 (516 mm)',516/25.4],
['Tioga Fastr-X 20 × 1-3/8 (530 mm)',530/25.4],['Tioga Fastr-X 20 × 1.60 (494 mm)',494/25.4],['Tioga Fastr-X 20 × 1.75 (507 mm)',507/25.4],
['Tioga Fastr-X 20 × 1.85 (515 mm)',515/25.4],['Tioga Fastr-X 24 × 1.75 (610 mm)',610/25.4],['Tioga Fastr React 20 × 1.60 (494 mm)',494/25.4],
['Tioga Fastr React 20 × 1.75 (507 mm)',507/25.4]]},
{g:'United',o:[
['United Direct 20 × 2.10 (512 mm)',512/25.4],['United Direct 20 × 2.30 (526 mm)',526/25.4],['United Direct 20 × 2.40 (532 mm)',532/25.4]]},
{g:'20 inch, generic size',o:[
['20 × 1.50',19.3],['20 × 1.60',19.5],['20 × 1.75',19.6],['20 × 1.85',20.0],['20 × 1.95',20.1],['20 × 2.10',20.2],
['20 × 1 1/8 (451)',20.1],['20 × 1 3/8 (451)',20.5],['OS20 × 1.75 (451 fat)',21.5],['20" nominal (chart standard)',20.0]]},
{g:'24 inch, generic size',o:[
['24 × 1.50',23.3],['24 × 1.75',23.6],['24 × 1.85',23.9],['24 × 1 1/8 (520)',22.8],['24 × 1 3/8 (520)',23.2],['24" nominal (chart standard)',24.0]]},
{g:'Other',o:[
['16 × 1.75 (Micro)',15.5],['18 × 1.75 (Mini)',17.5],['22 × 2.10',22.3],['26 × 2.10',26.2],['Custom: measure your wheel','custom']]}
];
var FRONT=[],REAR=[],i;
for(i=22;i<=52;i++)FRONT.push(i);
for(i=8;i<=25;i++)REAR.push(i);
var PI=Math.PI,IN2M=0.0254;
var root=section.querySelector('#lux-gear');if(!root||root.dataset.ready)return;root.dataset.ready='1';
var $=function(id){return root.querySelector('#'+id)};
var elF=$('lg-front'),elR=$('lg-rear'),elT=$('lg-tyre'),elRT=$('lg-revtyre'),elOD=$('lg-od'),elODU=$('lg-odunit');
var elTG=$('lg-target'),elTR=$('lg-target-ro'),elRU=$('lg-rounit'),elTol=$('lg-tol');
var state={front:44,rear:16,tyre:'20 × 1.75',mode:'gi',unit:'in',tab:'chart',revtyre:'20 × 1.75',rounit:'in',target:null};
var STORE='luxCalcsGear';
try{var s=JSON.parse(localStorage.getItem(STORE)||'{}');for(var k in s)state[k]=s[k];}catch(e){}
/* ?front=&rear=&tyre= from the light gearing calculator on product pages: take them, then drop them from the URL. */
try{var gq=new URLSearchParams(location.search),gqf=parseInt(gq.get('front'),10),gqr=parseInt(gq.get('rear'),10),gqt=gq.get('tyre'),gqHit=false;
if(FRONT.indexOf(gqf)!==-1){state.front=gqf;gqHit=true}
if(REAR.indexOf(gqr)!==-1){state.rear=gqr;gqHit=true}
if(gqt&&known(gqt)){state.tyre=gqt;state.revtyre=gqt;gqHit=true}
if(gqHit){gq.delete('front');gq.delete('rear');gq.delete('tyre');var gqs=gq.toString();history.replaceState(null,'',location.pathname+(gqs?'?'+gqs:'')+location.hash);}}catch(e){}
function fill(sel,arr,f){arr.forEach(function(v){var o=document.createElement('option');o.value=v;o.textContent=f?f(v):v;sel.appendChild(o);});}
fill(elF,FRONT,function(v){return v+'T'});fill(elR,REAR,function(v){return v+'T'});
function fillTyres(sel){TYRES.forEach(function(g){var og=document.createElement('optgroup');og.label=g.g;g.o.forEach(function(t){var o=document.createElement('option');o.value=t[0];o.textContent=t[0]+(t[1]==='custom'?'':'  ·  '+t[1].toFixed(1)+'"');og.appendChild(o);});sel.appendChild(og);});}
fillTyres(elT);fillTyres(elRT);
function known(name){for(var a=0;a<TYRES.length;a++)for(var b=0;b<TYRES[a].o.length;b++)if(TYRES[a].o[b][0]===name)return true;return false;}
if(!known(state.tyre))state.tyre='20 × 1.75';if(!known(state.revtyre))state.revtyre=state.tyre;
function oneOf(v,list,fallback){return list.indexOf(v)===-1?fallback:v}
state.front=oneOf(Number(state.front),FRONT,44);
state.rear=oneOf(Number(state.rear),REAR,16);
state.mode=oneOf(state.mode,['gi','ro','ratio'],'gi');
state.unit=oneOf(state.unit,['in','m'],'in');
state.rounit=oneOf(state.rounit,['in','m'],state.unit);
state.tab=oneOf(state.tab,['chart','rev'],'chart');
if(typeof state.target!=='number'||!isFinite(state.target)||state.target<=0)state.target=null;
function dia(name){for(var a=0;a<TYRES.length;a++)for(var b=0;b<TYRES[a].o.length;b++)if(TYRES[a].o[b][0]===name){var d=TYRES[a].o[b][1];if(d==='custom'){var v=parseFloat(elOD.value)||19.6;return elODU.value==='mm'?v/25.4:v;}return d;}return 19.6;}
function isCustom(name){return /^Custom/.test(name)}
function gi(f,r,d){return f/r*d}
function fmt(n,p){return n.toFixed(p===undefined?2:p)}
function save(){try{localStorage.setItem(STORE,JSON.stringify(state))}catch(e){}}
function roFromGi(g){return state.rounit==='m'?g*PI*IN2M:g*PI}
function giFromRo(r){return state.rounit==='m'?r/IN2M/PI:r/PI}
function writeTargets(src){
if(state.target==null)return;
if(src!=='gi')elTG.value=fmt(state.target,1);
if(src!=='ro')elTR.value=state.rounit==='m'?fmt(roFromGi(state.target),2):fmt(roFromGi(state.target),1);
}
function render(){
elF.value=state.front;elR.value=state.rear;elT.value=state.tyre;elRT.value=state.revtyre;elRU.value=state.rounit;
$('lg-custom').className='lg-field lg-custom'+(isCustom(state.tyre)?' on':'');
var d=dia(state.tyre),f=state.front,r=state.rear;
var g=gi(f,r,d),ro=g*PI,ratio=f/r;
$('lg-gi').textContent=fmt(g);
var diff=g-gi(44,16,20);
$('lg-gi-d').innerHTML='vs 44/16 chart standard (55.0&Prime;): <b>'+(diff>=0?'+':'')+fmt(diff,1)+'&Prime;</b>';
if(state.unit==='m'){$('lg-ro').textContent=fmt(ro*IN2M,3);$('lg-ro-u').textContent='metres per crank rev';$('lg-ro-m').innerHTML='<b>'+fmt(ro,1)+'&Prime;</b> · '+fmt(ro*2.54,0)+' cm';}
else{$('lg-ro').textContent=fmt(ro,1);$('lg-ro-u').textContent='inches per crank rev';$('lg-ro-m').innerHTML='<b>'+fmt(ro*IN2M,3)+' m</b> · '+fmt(ro/12,2)+' ft';}
$('lg-ratio').textContent=fmt(ratio,3);
$('lg-ratio-d').innerHTML='<b>'+f+' / '+r+'</b> · '+fmt(ratio*20,1)+'&Prime; on a nominal 20&Prime;';
if(state.unit==='m'){$('lg-dia').textContent=fmt(d*25.4,0);$('lg-dia-u').textContent='mm (outside)';}
else{$('lg-dia').textContent=fmt(d,2);$('lg-dia-u').textContent='inches (outside)';}
$('lg-dia-d').innerHTML='circumference <b>'+(state.unit==='m'?fmt(d*PI*2.54,1)+' cm':fmt(d*PI,1)+'&Prime;')+'</b>';
renderTable(g,d);
if(state.target==null){state.target=Math.round(g*10)/10;}
writeTargets();
renderRev();
save();
}
function cell(f,r,d){
if(state.mode==='ratio')return fmt(f/r,3);
var g=gi(f,r,d);
if(state.mode==='gi')return fmt(g,2);
var ro=g*PI;return state.unit==='m'?fmt(ro*IN2M,3):fmt(ro,1);
}
function renderTable(gcur,d){
var fi=FRONT.indexOf(state.front),ri=REAR.indexOf(state.rear);
var f0=Math.max(0,Math.min(fi-3,FRONT.length-7)),r0=Math.max(0,Math.min(ri-3,REAR.length-7));
var fs=FRONT.slice(f0,f0+7),rs=REAR.slice(r0,r0+7);
var h='<thead><tr><th class="lg-corner">cog down, ring across</th>';
fs.forEach(function(f){h+='<th'+(f===state.front?' class="lg-axis-on"':'')+'>'+f+'T</th>'});h+='</tr></thead><tbody>';
rs.forEach(function(r){h+='<tr><th'+(r===state.rear?' class="lg-axis-on"':'')+'>'+r+'T</th>';fs.forEach(function(f){
var g=gi(f,r,d),cls=(f===state.front&&r===state.rear)?'lg-cur':(Math.abs(g-gcur)<=1?'lg-near':'');
h+='<td class="'+cls+'" data-f="'+f+'" data-r="'+r+'">'+cell(f,r,d)+(state.mode!=='gi'?'<small>'+fmt(g,1)+'&Prime;</small>':'')+'</td>';
});h+='</tr>'});
$('lg-table').innerHTML=h+'</tbody>';
centreCurrentCell();
}
function centreCurrentCell(){
var cur=$('lg-table').querySelector('td.lg-cur');
if(!cur)return;
var box=cur.parentNode;
while(box&&box!==document.body&&box.className.indexOf('lg-scroll')===-1)box=box.parentNode;
if(!box||box===document.body)return;
if(box.scrollWidth<=box.clientWidth)return;         // nothing to scroll
var br=box.getBoundingClientRect();
if(!br.width)return;                                // panel still display:none
var cr=cur.getBoundingClientRect();
box.scrollLeft+=(cr.left-br.left)-(br.width-cr.width)/2;
}
function renderRev(){
var t=state.target,tol=parseFloat(elTol.value),d=dia(state.revtyre);
if(!(t>0)){$('lg-revtable').innerHTML='';$('lg-revnote').textContent='';return;}
var rows=[];
FRONT.forEach(function(f){REAR.forEach(function(r){var g=gi(f,r,d),df=g-t;if(Math.abs(df)<=tol)rows.push({f:f,r:r,g:g,df:df});});});
rows.sort(function(a,b){return Math.abs(a.df)-Math.abs(b.df)||a.f-b.f});
var roTol=state.rounit==='m'?fmt(tol*PI*IN2M,3)+' m':fmt(tol*PI,1)+'&Prime;';
var teeth='chainrings '+FRONT[0]+' to '+FRONT[FRONT.length-1]+'T and cogs '+REAR[0]+' to '+REAR[REAR.length-1]+'T';
$('lg-revnote').innerHTML='Looking for <b style="color:#fff">'+fmt(t,1)+'&Prime;</b> gear (rollout '+(state.rounit==='m'?fmt(roFromGi(t),2)+' m':fmt(roFromGi(t),1)+'&Prime;')+') ± '+tol+'&Prime; (≈ ± '+roTol+' rollout) on a '+fmt(d,1)+'&Prime; tyre. <b style="color:#fff">'+rows.length+'</b> combination'+(rows.length===1?'':'s')+' from '+teeth+', closest first.';
var h='<thead><tr><th>Gear</th><th>Gear inches</th><th>Rollout</th><th>Ratio</th><th>Diff</th><th></th></tr></thead><tbody>';
if(!rows.length)h+='<tr><td colspan="6" style="font:500 14px Poppins,sans-serif;color:#a3a3a3">Nothing within ±'+tol+'&Prime;. Widen the tolerance or check the tyre.</td></tr>';
rows.forEach(function(x){
var ro=x.g*PI,roS=state.rounit==='m'?fmt(ro*IN2M,3)+' m':fmt(ro,1)+'&Prime;';
var ex=Math.abs(x.df)<0.05,dc=ex?'':(x.df>0?'up':'dn');
h+='<tr class="'+(ex?'lg-exact':'')+'"><td class="lg-gear">'+x.f+' / '+x.r+'</td><td>'+fmt(x.g)+'&Prime;</td><td>'+roS+'</td><td>'+fmt(x.f/x.r,3)+'</td><td><span class="lg-diff '+dc+'">'+(ex?'exact':(x.df>0?'+':'')+fmt(x.df)+'&Prime; '+(x.df>0?'harder':'easier'))+'</span></td><td><button type="button" class="lg-use" data-f="'+x.f+'" data-r="'+x.r+'">Use</button></td></tr>';
});
$('lg-revtable').innerHTML=h+'</tbody>';
}
elF.onchange=function(){state.front=+this.value;state.target=null;render()};
elR.onchange=function(){state.rear=+this.value;state.target=null;render()};
elT.onchange=function(){state.tyre=this.value;if(!elRT.dataset.touched)state.revtyre=this.value;render()};
elRT.onchange=function(){state.revtyre=this.value;this.dataset.touched=1;renderRev();save()};
elOD.oninput=elODU.onchange=function(){render()};
elTG.oninput=function(){var v=parseFloat(this.value);if(v>0){state.target=v;writeTargets('gi');renderRev();save();}};
elTR.oninput=function(){var v=parseFloat(this.value);if(v>0){state.target=giFromRo(v);writeTargets('ro');renderRev();save();}};
elRU.onchange=function(){state.rounit=this.value;writeTargets();renderRev();save()};
elTol.onchange=function(){renderRev()};
root.addEventListener('click',function(e){
var b=e.target.closest('button,td');if(!b||!root.contains(b))return;
if(b.dataset.step){var arr=b.dataset.step==='front'?FRONT:REAR,key=b.dataset.step,idx=arr.indexOf(state[key])+(+b.dataset.d);if(idx>=0&&idx<arr.length){state[key]=arr[idx];state.target=null;render();}return;}
if(b.dataset.tab){state.tab=b.dataset.tab;applyTabs();save();return;}
if(b.dataset.mode){state.mode=b.dataset.mode;root.querySelectorAll('#lg-mode button').forEach(function(t){t.className=t.dataset.mode===state.mode?'on':''});render();return;}
if(b.dataset.unit){state.unit=b.dataset.unit;state.rounit=state.unit;root.querySelectorAll('#lg-units button').forEach(function(t){t.className=t.dataset.unit===state.unit?'on':''});render();return;}
if(b.dataset.f&&b.dataset.r){state.front=+b.dataset.f;state.rear=+b.dataset.r;if(b.tagName==='BUTTON'){state.tyre=state.revtyre;delete elRT.dataset.touched;state.target=null;root.scrollIntoView({behavior:'smooth'});}else{state.target=null;}render();return;}
});
function applyTabs(){root.querySelectorAll('.lg-tab').forEach(function(t){t.className='lg-tab'+(t.dataset.tab===state.tab?' on':'')});root.querySelectorAll('.lg-panel').forEach(function(p){p.className='lg-panel'+(p.dataset.panel===state.tab?' on':'')});}
applyTabs();
root.querySelectorAll('#lg-mode button').forEach(function(t){t.className=t.dataset.mode===state.mode?'on':''});
root.querySelectorAll('#lg-units button').forEach(function(t){t.className=t.dataset.unit===state.unit?'on':''});
render();
if(window.IntersectionObserver){
var chartBox=root.querySelector('.lg-scroll');
if(chartBox)new IntersectionObserver(function(entries){
entries.forEach(function(e){if(e.isIntersecting)centreCurrentCell();});
}).observe(chartBox);
}
}

function initChain(section) {
var root=section.querySelector('#lux-chain');if(!root||root.dataset.ready)return;root.dataset.ready='1';
var $=function(id){return root.querySelector('#'+id)};
var F=$('lux-f'),R=$('lux-r'),CS=$('lux-cs'),U=$('lux-unit'),T=$('lux-type'),LEN=$('lux-len');
var PITCH=12.7;
function calc(){
var f=parseInt(F.value,10),r=parseInt(R.value,10),cs=parseFloat(CS.value);
var unit=U.value,half=T.value==='half';
if(!(f>2&&r>2&&cs>0)){show(null,'incomplete');return;}
var C=unit==='in'?cs*25.4:cs;
var rf=PITCH/(2*Math.sin(Math.PI/f)),rr=PITCH/(2*Math.sin(Math.PI/r));
var d=rf-rr;if(Math.abs(d)>=C){show(null,'short');return;}
var a=Math.asin(d/C);
var L=2*Math.sqrt(C*C-d*d)+rf*(Math.PI+2*a)+rr*(Math.PI-2*a);
var exact=L/PITCH;
var links=half?Math.ceil(exact-1e-9):Math.ceil(exact/2-1e-9)*2;
var extraMm=(links-exact)*PITCH/2;
show({exact:exact,links:links,extraMm:extraMm,f:f,r:r});
}
function show(o,why){
var err=$('lux-err'),res=$('lux-result');
var newLen=parseInt(LEN.value,10)||112;
$('lux-remove-label').textContent='Cut from '+newLen+'-link';
if(!o){
res.hidden=true;
err.textContent = why==='short'
? 'Chainstay is too short for those sprockets. Check your numbers.'
: 'Enter the sprocket, driver and chainstay to get a link count.';
err.style.display='block';
$('lux-slack').textContent='–';$('lux-remove').textContent='–';$('lux-ratio').textContent='–';return;
}
res.hidden=false;err.style.display='none';
$('lux-links').textContent=o.links;
$('lux-exact').innerHTML='Exact length<b>'+o.exact.toFixed(1)+' links</b>'+(o.exact*PITCH).toFixed(0)+' mm &middot; '+(o.exact*0.5).toFixed(1)+' in';
var ex=o.extraMm;$('lux-slack').textContent=ex<0.05?'0 mm':'~'+ex.toFixed(1)+' mm';
var rem=newLen-o.links;$('lux-remove').textContent=rem>=0?rem+(rem===1?' link':' links'):(-rem)+' short';
$('lux-ratio').textContent=(o.f/o.r).toFixed(2)+':1';
}
[F,R,CS,T,LEN].forEach(function(el){el.addEventListener('input',calc);el.addEventListener('change',calc);});
U.addEventListener('change',function(){
var v=parseFloat(CS.value);
if(v>0){if(U.value==='mm'&&CS.dataset.unit!=='mm'){CS.value=(v*25.4).toFixed(1);CS.step='0.5';}else if(U.value==='in'&&CS.dataset.unit!=='in'){CS.value=(v/25.4).toFixed(2);CS.step='0.05';}}
CS.dataset.unit=U.value;calc();
});
CS.dataset.unit='in';
/* ?f=&r=&cs=&unit=&type=&len= from the light chain calculator on product pages: take them, then drop them from the URL. */
try{var cq=new URLSearchParams(location.search),cqHit=false;
var cqSet=function(el,key,ok){var v=cq.get(key);if(v===null)return;if(ok(v)){el.value=v;cqHit=true;}};
cqSet(U,'unit',function(v){return v==='in'||v==='mm'});
cqSet(F,'f',function(v){return /^\d{1,2}$/.test(v)});
cqSet(R,'r',function(v){return /^\d{1,2}$/.test(v)});
cqSet(CS,'cs',function(v){return /^\d+(\.\d+)?$/.test(v)});
cqSet(T,'type',function(v){return v==='full'||v==='half'});
cqSet(LEN,'len',function(v){for(var i=0;i<LEN.options.length;i++)if(LEN.options[i].value===v)return true;return false});
if(cqHit){CS.dataset.unit=U.value;['f','r','cs','unit','type','len'].forEach(function(k){cq.delete(k)});var cqs=cq.toString();history.replaceState(null,'',location.pathname+(cqs?'?'+cqs:'')+location.hash);}}catch(e){}
calc();
}

function initStyle(section) {
var root=section.querySelector('#lux-calcs');
if(!root||root.dataset.lcStyleReady)return;
root.dataset.lcStyleReady='1';
var btns=root.querySelectorAll('.lc-mode-btn');
if(!btns.length)return;
var FONT='https://fonts.googleapis.com/css2?family=Share+Tech+Mono&display=swap';
function isRetro(){return root.classList.contains('lux-calcs--retro')}
function sync(){
var on=isRetro();
Array.prototype.forEach.call(btns,function(b){
var mine=b.getAttribute('data-lc-style')==='retro';
b.setAttribute('aria-pressed',mine===on?'true':'false');
});
}
function ensureFont(){
if(document.getElementById('lux-calcs-font'))return;
var l=document.createElement('link');l.id='lux-calcs-font';l.rel='stylesheet';l.href=FONT;document.head.appendChild(l);
}
Array.prototype.forEach.call(btns,function(b){
b.addEventListener('click',function(){
var want=b.getAttribute('data-lc-style')==='retro';
if(want===isRetro()){sync();return}
if(want)ensureFont();
root.classList.toggle('lux-calcs--retro',want);
try{localStorage.setItem('luxCalcsStyle',want?'retro':'standard')}catch(e){}
sync();
});
});
sync();
}

function initSection(section) {
initTabs(section);
initStyle(section);
initSpoke(section);
initGear(section);
initChain(section);
}
function initAll(scope) {
var nodes = (scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-lux-calculators]');
Array.prototype.forEach.call(nodes, initSection);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
else initAll(document);
document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
